import {AUTO_MODEL_ID} from './auto-model'

export const AUTO_TIERS = ['eco', 'balanced', 'max'] as const

export type AutoTier = (typeof AUTO_TIERS)[number]

export const DEFAULT_AUTO_TIER: AutoTier = 'balanced'

export type AutoTierMetadata = {
  value: AutoTier
  label: string
  description: string
}

export const AUTO_TIER_METADATA: readonly AutoTierMetadata[] = [
  {
    value: 'eco',
    label: 'Eco',
    description: 'Optimizes for lower cost',
  },
  {
    value: 'balanced',
    label: 'Balanced',
    description: 'Balances cost, quality, and speed',
  },
  {
    value: 'max',
    label: 'Max',
    description: 'Prioritizes quality',
  },
]

export function parseAutoTier(value: unknown): AutoTier {
  if (typeof value !== 'string') return DEFAULT_AUTO_TIER

  const normalized = value.trim().toLowerCase()
  return AUTO_TIERS.find(tier => tier === normalized) ?? DEFAULT_AUTO_TIER
}

export function getAutoTierForModel(model: string | undefined, autoTier: AutoTier): AutoTier | undefined {
  return model === AUTO_MODEL_ID ? autoTier : undefined
}
